/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelWith3ValuesValue
 */
export interface LabelWith3ValuesValue {
    /**
     * 
     * @type {string}
     * @memberof LabelWith3ValuesValue
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof LabelWith3ValuesValue
     */
    value1: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith3ValuesValue
     */
    value2: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith3ValuesValue
     */
    value3: number;
}

/**
 * Check if a given object implements the LabelWith3ValuesValue interface.
 */
export function instanceOfLabelWith3ValuesValue(value: object): value is LabelWith3ValuesValue {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value1' in value) || value['value1'] === undefined) return false;
    if (!('value2' in value) || value['value2'] === undefined) return false;
    if (!('value3' in value) || value['value3'] === undefined) return false;
    return true;
}

export function LabelWith3ValuesValueFromJSON(json: any): LabelWith3ValuesValue {
    return LabelWith3ValuesValueFromJSONTyped(json, false);
}

export function LabelWith3ValuesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelWith3ValuesValue {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value1': json['value1'],
        'value2': json['value2'],
        'value3': json['value3'],
    };
}

export function LabelWith3ValuesValueToJSON(value?: LabelWith3ValuesValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'value1': value['value1'],
        'value2': value['value2'],
        'value3': value['value3'],
    };
}

